var map = {
	"./businessclass/desktop_da.webp": [
		441786,
		41786
	],
	"./businessclass/desktop_en.webp": [
		32062,
		32062
	],
	"./businessclass/desktop_es.webp": [
		118053,
		18053
	],
	"./businessclass/desktop_no.webp": [
		591374,
		91374
	],
	"./businessclass/desktop_sv.webp": [
		354076,
		54076
	],
	"./businessclass/mobile_da.webp": [
		359904,
		59904
	],
	"./businessclass/mobile_en.webp": [
		871032,
		71032
	],
	"./businessclass/mobile_es.webp": [
		59647,
		59647
	],
	"./businessclass/mobile_no.webp": [
		258452,
		58452
	],
	"./businessclass/mobile_sv.webp": [
		605314,
		5314
	],
	"./businessclass/tablet_da.webp": [
		634922,
		34922
	],
	"./businessclass/tablet_en.webp": [
		78190,
		78190
	],
	"./businessclass/tablet_es.webp": [
		436789,
		36789
	],
	"./businessclass/tablet_no.webp": [
		743678,
		43678
	],
	"./businessclass/tablet_sv.webp": [
		829772,
		29772
	],
	"./radissonhotels/desktop_da.webp": [
		989504,
		89504
	],
	"./radissonhotels/desktop_de.webp": [
		510844,
		10844
	],
	"./radissonhotels/desktop_en.webp": [
		65560,
		65560
	],
	"./radissonhotels/desktop_es.webp": [
		989471,
		89471
	],
	"./radissonhotels/desktop_fi.webp": [
		953298,
		53298
	],
	"./radissonhotels/desktop_fr.webp": [
		586891,
		86891
	],
	"./radissonhotels/desktop_it.webp": [
		195334,
		95334
	],
	"./radissonhotels/desktop_nl.webp": [
		560497,
		60497
	],
	"./radissonhotels/desktop_no.webp": [
		782388,
		82388
	],
	"./radissonhotels/desktop_se.webp": [
		373235,
		73235
	],
	"./radissonhotels/mobile_da.webp": [
		374446,
		74446
	],
	"./radissonhotels/mobile_de.webp": [
		468114,
		68114
	],
	"./radissonhotels/mobile_en.webp": [
		680093,
		2474
	],
	"./radissonhotels/mobile_es.webp": [
		729161,
		29161
	],
	"./radissonhotels/mobile_fi.webp": [
		852332,
		52332
	],
	"./radissonhotels/mobile_fr.webp": [
		393153,
		93153
	],
	"./radissonhotels/mobile_it.webp": [
		251660,
		51660
	],
	"./radissonhotels/mobile_nl.webp": [
		775611,
		75611
	],
	"./radissonhotels/mobile_no.webp": [
		188762,
		88762
	],
	"./radissonhotels/mobile_se.webp": [
		954669,
		54669
	],
	"./radissonhotels/tablet_da.webp": [
		301644,
		1644
	],
	"./radissonhotels/tablet_de.webp": [
		644816,
		44816
	],
	"./radissonhotels/tablet_en.webp": [
		813036,
		13036
	],
	"./radissonhotels/tablet_es.webp": [
		156203,
		56203
	],
	"./radissonhotels/tablet_fi.webp": [
		81214,
		81214
	],
	"./radissonhotels/tablet_fr.webp": [
		978423,
		78423
	],
	"./radissonhotels/tablet_it.webp": [
		323394,
		23394
	],
	"./radissonhotels/tablet_nl.webp": [
		163429,
		63429
	],
	"./radissonhotels/tablet_no.webp": [
		385976,
		85976
	],
	"./radissonhotels/tablet_se.webp": [
		688399,
		88399
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 259806;
module.exports = webpackAsyncContext;